<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import RelatedFeedPost from '$components/Feed/RelatedFeedPost.svelte';
    import { query } from '$lib/apollo/SvelteApollo.js';
    import { RelatedFeedPostFragmentDoc, SharedPostQueryDocument } from '$gql/graphql.js';
    import { useFragment } from '$gql/fragment-masking.js';
    import { cx } from '$lib/utils/cx.js';
    import Spinner from '$components/Spinner/Spinner.svelte';

    export let sharedPostId: number;

    const dispatch = createEventDispatcher<{
        ids: number[];
    }>();

    const { result, setVariables } = query(SharedPostQueryDocument, {
        variables: { id: sharedPostId },
    });

    $: post = useFragment(RelatedFeedPostFragmentDoc, $result.data?.post);

    $: setVariables({ id: sharedPostId });
    $: linkMetaDataId = $result.data?.post.selfLinkMetaData?.id;
    $: if (linkMetaDataId) {
        dispatch('ids', [linkMetaDataId]);
    }
</script>

{#if $result.loading}
    <div
        class={cx(
            'bg-white p-5 border rounded-lg border-gray-300 shadow boxify flex items-center justify-center m-6',
        )}
    >
        <Spinner />
    </div>
{:else if post != null}
    <RelatedFeedPost {post} />
{/if}
